// extracted by mini-css-extract-plugin
export default {"positionText":"PositionCorrection_positionText__3KtNp"};